import { Injectable } from '@angular/core';
import { QueryObject } from '@pc/common';

@Injectable({ providedIn: 'root' })
export class PcStringUtils {
  removeCharFromString(str: string, char: string, includeSpaces: boolean): string {
    let result = str;
    if (includeSpaces) {
      result = result.replace(new RegExp(char, 'g'), '');
    } else {
      result = result.replace(char, '');
    }
    return result;
  }

  parseQueryString(url: string): QueryObject[] {
    const queryString = url.split('?')[1]; // Extract query string from the URL
    if (!queryString) {
      return [];
    }

    const queryParameters = queryString.split('&');
    const queryObjects: QueryObject[] = [];

    for (const param of queryParameters) {
      const [name, value] = param.split('=');
      const queryObject: QueryObject = {
        name: decodeURIComponent(name),
        value: decodeURIComponent(value)
      };
      queryObjects.push(queryObject);
    }
    return queryObjects;
  }

  addAutoBackSlash(value: string): string {
    const numericValue = value.replace(/[^\d]/g, '');
    if (numericValue.length === 0) {
      return '';
    }
    let formattedValue = numericValue.slice(0, 2);
    if (numericValue.length > 2) {
      formattedValue += '/';
    }
    if (numericValue.length >= 2 && numericValue.length <= 4) {
      formattedValue += numericValue.slice(2);
    } else if (numericValue.length > 4) {
      formattedValue += numericValue.slice(2, 4) + '/';
      formattedValue += numericValue.slice(4, 8);
    }

    return formattedValue;
  }

  getStringWithoutLastItem(strWithComma: string): string {
    const lastIndex = strWithComma.lastIndexOf(',');
    return lastIndex !== -1 ? strWithComma.slice(0, lastIndex) : '';
  }

  getLongestString(givenFullString: string): string {
    const fullString = givenFullString;
    const stringArray = fullString.split(',');

    if (stringArray.length === 1 && stringArray[0] === '') {
      return '';
    }

    return stringArray.reduce((longest, current) => {
      return current.length > longest.length ? current : longest;
    });
  }

  formatNumberWithCommas(number: number): string {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
